import styles from "./styles.module.sass";

const PAGE_SIZES = [10, 20, 30, 40, 50];

const NavButton = ({ onClick, disabled, children }) => (
  <button className="border rounded p-1" onClick={onClick} disabled={disabled}>
    {children}
  </button>
);

function Pagination({
  pagination,
  tablePageSize,
  tableSetPageSize,
  tableSetFirstPageIndex,
  tableSetLastPageIndex,
  tableSetPreviousPage,
  previousPageAllowed,
  nextPageAllowed,
  customPageSizeAllowed,
  tableSetNextPage,
  paginationTextValue,
}) {
  if (!pagination) return null;

  return (
    <div
      className={styles.paginationStyle}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px",
        justifyContent: "flex-start",
      }}
    >
      {customPageSizeAllowed && (
        <select
          style={{
            background: "#6c757d",
            color: "#ffffff",
            borderRadius: "4px",
          }}
          value={tablePageSize}
          onChange={tableSetPageSize}
        >
          {PAGE_SIZES.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      )}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          ...(!customPageSizeAllowed && { justifyContent: "center" }),
        }}
      >
        <NavButton
          onClick={tableSetFirstPageIndex}
          disabled={previousPageAllowed}
        >
          {"<<"}
        </NavButton>
        <NavButton
          onClick={tableSetPreviousPage}
          disabled={previousPageAllowed}
        >
          {"<"}
        </NavButton>
        <span
          className="gap-1"
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          Strana <strong>{paginationTextValue}</strong>
        </span>
        <NavButton onClick={tableSetNextPage} disabled={nextPageAllowed}>
          {">"}
        </NavButton>
        <NavButton onClick={tableSetLastPageIndex} disabled={nextPageAllowed}>
          {">>"}
        </NavButton>
      </div>
    </div>
  );
}

export default Pagination;
